export default __webpack_public_path__ + "static/media/bb6.afa2bd52.png";